import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";

const PushNotification = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [reminderToggle, setReminderToggle] = useState(true);
  const [exhibitionToggle, setExhibitionToggle] = useState(false);
  const [prospectToggle, setProspectToggle] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const handleReminderToggle = () => {
    setReminderToggle(!reminderToggle);
  };

  const handleExhibitionToggle = () => {
    setExhibitionToggle(!exhibitionToggle);
  };
  const handleProspectToggle = () => {
    setProspectToggle(!prospectToggle);
  };

  return (
    <>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Profile" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px] font-bold">Push Notification</p>
      </div>

      <div className="ml-4 mt-8 border w-[70%] p-2 flex justify-around rounded-lg profile-one profile-section-width ">
        <div className="flex items-center">
          <p>Task Reminder</p>
          <div className="text-[12px] ml-4">
            <label className="blue-slider-toggle">
              <input
                type="checkbox"
                checked={reminderToggle}
                onChange={handleReminderToggle}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>

        <div className="vl"></div>

        <div className="flex items-center">
          <p>Exhibition Updates</p>
          <div className="text-[12px] ml-4">
            <label className="blue-slider-toggle">
              <input
                type="checkbox"
                checked={exhibitionToggle}
                onChange={handleExhibitionToggle}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>

        <div className="vl"></div>

        <div className="flex items-center">
          <p>Prospect/ Customer Updates</p>
          <div className="text-[12px] ml-4">
            <label className="blue-slider-toggle">
              <input
                type="checkbox"
                checked={prospectToggle}
                onChange={handleProspectToggle}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default PushNotification;
